module.exports = __webpack_public_path__ + "static/media/process.af0048a5.svg";